import React from "react";
import { Typography, Box } from "@material-ui/core";
import { useMutation } from "@apollo/client";
import { DPPermissionGate, DPRestrictedPage } from "Components/DP";
import { ApiResponseLogCategory } from "generated/graphql";
import mutations from "Shared/mutations";
import queries from "Shared/queries";
import { UploadGrossEarningsResponse } from "Shared/types/GrossEarnings";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import ApiResponseLogTable from "../ApiResponseLogTable/ApiResponseLogTable";
import UploadButton from "../UploadButton/UploadButton";
import GrossEarningsTable from "./GrossEarningsTable/GrossEarningsTable";

const GrossEarningsPage = () => {
  const [uploadGrossEarningsFile] = useMutation<UploadGrossEarningsResponse>(
    mutations.UPLOAD_GROSS_EARNINGS_FILE
  );
  const refetchQueries = [
    {
      query: queries.GET_GROSS_EARNINGS_TRANSMISSIONS_FILES_QUERY,
    },
  ];

  const onPageLoad = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.GrossEarningsPageViewed,
    });
  };

  return (
    <DPRestrictedPage
      title="Gross Earnings"
      onPageLoad={onPageLoad}
      permissionKey="canViewDataExchange"
    >
      <DPPermissionGate permissionKeys={["canCreateGrossEarnings"]}>
        <Box pb={3}>
          <UploadButton
            mutationResponse="uploadGrossEarnings"
            refetch={refetchQueries}
            uploadMutation={uploadGrossEarningsFile}
            mutationName="uploadGrossEarningsInput"
          />
        </Box>
      </DPPermissionGate>
      <Box>
        <Typography variant={"h2"}>File Uploads</Typography>
      </Box>
      <GrossEarningsTable />
      <ApiResponseLogTable
        logCategory={ApiResponseLogCategory.GrossEarnings}
        title="API Log (POST /gross_earnings)"
      />
    </DPRestrictedPage>
  );
};

export default GrossEarningsPage;
